import Icon from "../Icon";
import Button from "../Button";
import ButtonGroup from "../Button/Group";
import { styles } from "./styles";
import { type ChatHeaderProps } from "./types";

/**
 * `Chat.Header` is a component that renders a header for a chat interface.
 * It can display a title, an optional prefix icon, and an optional close button.
 * @example
 * ```tsx
 * <Chat headerRef={headerRef}>
 *   <Chat.Header elemRef={headerRef}>My Chat</Chat.Header>
 *   {...}
 * </Chat>
 * ```
 */
function ChatHeader({
  children,
  onClose,
  elemRef,
  prefix = children ? (
    <Icon name="Spark" fill="var(--color-border-primary)" />
  ) : undefined
}: ChatHeaderProps) {
  if (!children && !onClose && !prefix) {
    return null;
  }

  return (
    <div className="kit-chat-header" ref={elemRef} css={[styles.header.base]}>
      {prefix}
      <span css={styles.header.title}>{children}</span>
      {onClose && (
        <ButtonGroup>
          <Button
            variant="ghost"
            prefix={<Icon name="X" fill="var(--color-tertiary)" />}
            onClick={onClose}
            ariaLabel="Close chat"
          />
        </ButtonGroup>
      )}
    </div>
  );
}

export default ChatHeader;
